<template>
  <div id="app">
    
<router-view></router-view>   
  </div>
</template>

<script>



export default {
  watch: {
  $route() {
    document.body.style.overflow = '';
  }
}


}

</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,700;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap');


  body{
    position: relative;
    padding: 0;
    margin: 0;
    height: 100%;
    font-family: Arial, Helvetica, sans-serif;

  }



</style>


